import { useMutation } from '@tanstack/react-query';
import { falconClient } from '../@clients';
import { password_api_account_user_path } from '@/utils/routes';

interface changePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export const useChangePassword = () => {
  return useMutation({
    mutationFn: async ({
      currentPassword,
      newPassword,
    }: changePasswordParams) => {
      await falconClient.patch(password_api_account_user_path(), {
        password: {
          current_password: currentPassword,
          new_password: newPassword,
        },
      });
    },
  });
};
